import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { PICFLOW_CONFIG } from '../picflow-config';
import { ObservableDataLoaderService } from './observable-data-loader.service';

export interface DomainInfo {
  domainInfo: {
    input: string;
    tld: string;
    sld: string;
    domain: string;
    subdomain: string;
    listed: true;
  };
  isEmailProvider: boolean;
  isBurner: boolean;
  organization?: {
    name?: string;
    website_url?: string;
    phone?: string;
    twitter_url?: string;
    linkedin_url?: string;
    facebook_url?: string;
    logo_url?: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class DomainInfoService {
  private http = inject(HttpClient);
  private config = inject(PICFLOW_CONFIG);
  private loader = inject(ObservableDataLoaderService);

  getDomainInfo(domain: string): Observable<DomainInfo> {
    if (this.config.env === 'local')
      return of(<DomainInfo>{
        domainInfo: {
          subdomain: 'clerk-satallite',
        },
        organization: {
          name: 'FakeOrg',
          logo_url: 'https://zenprospect-production.s3.amazonaws.com/uploads/pictures/65b71793fdc3b10001f71c3f/picture',
          facebook_url: 'https://www.facebook.com/fakeorg',
          twitter_url: 'https://twitter.com/fakeorg',
          website_url: 'https://fakeorg.com',
          linkedin_url: 'https://www.linkedin.com/company/fakeorg',
          phone: '+1123-456-7890',
        },
      });
    return this.loader.get(`domain-info/${domain}`, () =>
      this.http.get<DomainInfo>(`/domain-info/${domain}`).pipe(
        catchError(err => {
          console.error(err);
          return of(<DomainInfo>{
            domainInfo: {},
          });
        })
      )
    );
  }
}
